export default __webpack_public_path__ + "static/christian_connection-2c5947164eee939683d88e457c1d13ae.mp4";